export default __webpack_public_path__ + "24bb3751f5277f3b3d8c799a4b0fb3d9.svg";